(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('TimeseriesDeleteController',TimeseriesDeleteController);

    TimeseriesDeleteController.$inject = ['$uibModalInstance', 'entity', 'Timeseries'];

    function TimeseriesDeleteController($uibModalInstance, entity, Timeseries) {
        var vm = this;

        vm.timeseries = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Timeseries.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
